










































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { AuthModule } from "@/stores/modules/AuthModule";
import { mapState, mapGetters } from "vuex";
import { Role } from "@/lib/UserRole";

@Component({
  computed: {
    ...mapGetters(["isUserLoggedIn"]),
    ...mapState({
      userName: (s: any) => s.auth.userName,
      userRoles: (s: any) => s.auth.userRoles
    })
  }
})
export default class HeaderComponent extends Vue {
  public isUserLoggedIn!: boolean;
  public userName!: string;
  public userRoles!: number;

  constructor() {
    super();
  }

  private allRoutes: any[] = [];
  private allMainRoutes: any[] = [];
  private allManageRoutes: any[] = [];
  private allTeamsRoutes: any[] = [];

  private mounted() {
    this.updateNav();
  }

  @Watch("userName")
  private onUserChange() {
    this.updateNav();
  }

  private updateNav() {
    const generallyExclude = ["login", "about", "home"];

    const manageNames = [
      "manageJokers",
      "manageChallenge",
      "manageGroups",
      "manageUsers",
      "manageEvents"
    ];

    const teamsNames = [
      "teamsGroups",
      "teamsSubmitStations",
      "teamsSolveChallenge"
    ];

    const routes = (this.$router as any).options.routes.filter(
      (x: any) => !generallyExclude.includes(x.name)
    );
    this.allRoutes = [];
    this.allMainRoutes = [];
    this.allManageRoutes = [];

    for (const route of routes!) {
      if (!this.isRouteVisible(route)) continue;
      const pr = {
        name: route.name,
        title: route.meta.title,
        path: route.path,
        isActive: false
      };
      this.allRoutes.push(pr);
      if (manageNames.includes(route.name)) this.allManageRoutes!.push(pr);
      else if (teamsNames.includes(route.name)) this.allTeamsRoutes!.push(pr);
      else this.allMainRoutes!.push(pr);
    }

    const active = this.allRoutes!.find(x => this.isSiteVisible(x.name));
    if (active) active.isActive = true;
  }

  isRouteVisible(route: any) {
    // route doesn't exists
    if (!route) {
      return false;
    }
    // No auth required or superadmin
    else if (!route.meta || !route.meta.auth || (this as any).isSuperAdmin()) {
      return true;
    }
    // Auth is required, but user is not logged in
    else if (route.meta.auth && !this.isUserLoggedIn) {
      return false;
    }
    // Check if auth is valid
    else if (!route.meta.visibleFor) {
      return false;
    }
    // Check roles
    else if ((this.userRoles & route.meta.visibleFor) > 0) {
      return true;
    }
    // This shouldn't be called
    else {
      return false;
    }
  }

  isSiteVisible(name: string): boolean {
    return name === this.$route.name;
  }

  logout() {
    AuthModule.Logout();
    this.$router.push("login");
  }
}
